import BaseEnumType from "../../common/base-enum-type";

const DownType = Object.freeze({
    Normal: new BaseEnumType("N", "Normal"),
    AutomaticFirstDown: new BaseEnumType("1", "Automatic First Down"),
    LossOfDownOnPLay: new BaseEnumType("+", "Loss Of Down On Play")
});

export default DownType;
